export default __webpack_public_path__ + "static/media/mo_art.f4d4e70e.png";